// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"245":"1a5e57ff0cd2747373e0","453":"eebbcbf55ad033aff3e4"}[chunkId] + ".js";
};